import React from "react"
import { Globe, Instagram, Linkedin } from "react-feather"

const SocialLinks = () => {
    return (
        <div className="w-full ">
            <ul className="grid md:grid-cols-2 gap-2  *:items-center">
                <li>
                    <a
                        href="https://hotspot.kau.se/"
                        className="flex justify-between items-center p-4 py-2 rounded-lg fg-color-3 border border-neutral-200 dark:border-neutral-700 underline hover:bg-neutral-200 dark:hover:bg-neutral-800"
                    >
                        Hotspot.kau.se
                        <Globe size={24} />
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.instagram.com/hotspotkau/"
                        className="flex justify-between items-center p-4 py-2 rounded-lg fg-color-3 border border-neutral-200 dark:border-neutral-700 underline hover:bg-neutral-200 dark:hover:bg-neutral-800"
                    >
                        Instagram
                        <Instagram size={24} />
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.tiktok.com/@hotspotkau"
                        className="flex justify-between items-center p-4 py-2 rounded-lg fg-color-3 border border-neutral-200 dark:border-neutral-700 underline hover:bg-neutral-200 dark:hover:bg-neutral-800"
                    >
                        TikTok
                        <div className="size-6 flex items-center justify-center">
                            <svg
                                width="16"
                                height="18"
                                viewBox="0 0 16 18"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12.44 2.82C11.7566 2.03953 11.3799 1.0374 11.38 0H8.29V12.4C8.26666 13.0712 7.98352 13.7071 7.50031 14.1735C7.01709 14.6399 6.3716 14.9004 5.7 14.9C4.28 14.9 3.1 13.74 3.1 12.3C3.1 10.58 4.76 9.29 6.47 9.82V6.66C3.02 6.2 0 8.88 0 12.3C0 15.63 2.76 18 5.69 18C8.83 18 11.38 15.45 11.38 12.3V6.01C12.633 6.90985 14.1374 7.39265 15.68 7.39V4.3C15.68 4.3 13.8 4.39 12.44 2.82Z"
                                    className="fill-neutral-700 dark:fill-neutral-300"
                                />
                            </svg>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.linkedin.com/company/hotspot-kau/"
                        className="flex justify-between items-center p-4 py-2 rounded-lg fg-color-3 border border-neutral-200 dark:border-neutral-700 underline hover:bg-neutral-200 dark:hover:bg-neutral-800"
                    >
                        LinkedIn
                        <Linkedin size={24} />
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default SocialLinks
